export const MANIFEST = 'manifest';

// Plugin types
export const PLUGIN_TYPE_COURSE = 'course';
export const PLUGIN_TYPE_UNIT = 'unit';
export const PLUGIN_TYPE_LESSON = 'lesson';
export const PLUGIN_TYPE_SCREEN = 'screen';
export const PLUGIN_TYPE_COMPONENT = 'component';
export const PLUGIN_TYPE_PATHWAY = 'pathway';
